<template>
  <div>
    <div class="section" :class="$mq">
      <div class="title">{{ $t("step2.consumption.title") }}</div>
      <div class="container inline center h-item-margin margin no-legend">
        <span class="check-frame">{{ $t(`step2.consumption.yes`) }}</span>
        <label for="knowConsumption" class="switch">
          <input
            type="checkbox"
            id="knowConsumption"
            name="knowConsumption"
            v-model="knowConsumption"
          />
          <span class="slider"></span>
        </label>
        <span class="check-frame">{{ $t(`step2.consumption.no`) }}</span>
      </div>

      <div class="container inline top margin-top" v-if="knowConsumption">
        <label
          :for="`index-${item.meterType}`"
          v-for="item in activeConsumptions"
          :key="item.meterType"
        >
          <h4>{{ $t(`step2.consumption.${item.meterType}`) }}</h4>
          <ValidationProvider
            rules="required|numeric"
            v-slot="{ errors }"
            :customMessages="{ required: $t('step2.consumption.required') }"
          >
          <div class="inline">
            <input
              type="number"
              :id="`index-${item.meterType}`"
              :name="`index-${item.meterType}`"
              v-model="item.value"
              class="input kwh"
              @change="unvalidate()"
            />
            <span class="margin small">{{ $t('kwh') }}</span>
          </div>
            <span class="input-error">{{ errors[0] }}</span>
          </ValidationProvider>
        </label>
      </div>
    </div>
    <EmptyHouse v-if="!knowConsumption"></EmptyHouse>
    <div v-if="!emptyHouse">
      <Inhabitant v-if="!knowConsumption"></Inhabitant>
      <HouseSize v-if="!knowConsumption"></HouseSize>
      <Occupation v-if="!knowConsumption"></Occupation>
      <HeaterType v-if="!knowConsumption"></HeaterType>
      <WaterType v-if="!knowConsumption"></WaterType>
      <HomeAppliance v-if="!knowConsumption && hasElec"></HomeAppliance>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import EmptyHouse from "./EmptyHouse";
import Inhabitant from "./Inhabitant";
import HouseSize from "./HouseSize";
import HeaterType from "./HeaterType";
import WaterType from "./WaterType";
import HomeAppliance from "./HomeAppliance";
import Occupation from "./Occupation";

export default {
  computed: {
    ...mapState("consumption", ["meterType", "consumptions", "emptyHouse"]),
    ...mapGetters("consumption", ["activeConsumptions"]),
    ...mapGetters("energy", ["hasElec", "hasGas"]),
    knowConsumption: {
      get() {
        return this.$store.state.consumption.knowConsumption;
      },
      set(value) {
        this.$store.commit("consumption/setKnowConsumption", value);
      }
    }
  },
  methods: {
    unvalidate() {
      this.$store.commit("comparison/reset");
      this.$store.commit("consumption/setValid", false);
      this.$store.commit("calculation/setValid", false);
    }
  },
  components: {
    EmptyHouse,
    Inhabitant,
    HouseSize,
    HeaterType,
    WaterType,
    HomeAppliance,
    Occupation
  }
};
</script>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/views/consumption/KnowConsumption/index.vue